module.exports = __webpack_public_path__ + "d21c2202ce4c4e05bb8672eb0729e73b.svg";